import React from 'react';
import Card from '../ui/Card';
import { StoreIcon, CheckCircleIcon, AlertTriangleIcon, TrendingUpIcon, ServerCrashIcon } from 'lucide-react';
import { DashboardFilters } from '../../pages/Dashboard';
const allActivities = [{
  id: 1,
  type: 'alert',
  title: 'Failed Transaction Spike',
  desc: 'Unusual failure rate detected on POS terminals in Lahore region.',
  time: '10 mins ago',
  timeValue: 10,
  icon: TrendingUpIcon,
  color: 'text-rose-500',
  bg: 'bg-rose-100 dark:bg-rose-900/50',
  border: 'border-rose-200 dark:border-rose-800'
}, {
  id: 2,
  type: 'merchant',
  title: 'New Merchant Registered',
  desc: 'Al-Fatah Supermarket (M-20993) has completed initial registration.',
  time: '25 mins ago',
  timeValue: 25,
  icon: StoreIcon,
  color: 'text-primary-500',
  bg: 'bg-primary-100 dark:bg-primary-900/50',
  border: 'border-primary-200 dark:border-primary-800'
}, {
  id: 3,
  type: 'approval',
  title: 'Merchant Approved',
  desc: 'Khaadi (M-10554) KYC approved by checker. Ready for terminal deployment.',
  time: '1 hour ago',
  timeValue: 60,
  icon: CheckCircleIcon,
  color: 'text-emerald-500',
  bg: 'bg-emerald-100 dark:bg-emerald-900/50',
  border: 'border-emerald-200 dark:border-emerald-800'
}, {
  id: 4,
  type: 'warning',
  title: 'Large Transaction Alert',
  desc: 'Transaction of PKR 2.5M flagged for manual review (Daraz.pk).',
  time: '2 hours ago',
  timeValue: 120,
  icon: AlertTriangleIcon,
  color: 'text-orange-500',
  bg: 'bg-orange-100 dark:bg-orange-900/50',
  border: 'border-orange-200 dark:border-orange-800'
}, {
  id: 5,
  type: 'system',
  title: 'System Alert',
  desc: 'Brief latency observed in RAAST RTP API endpoint. Resolved automatically.',
  time: '3 hours ago',
  timeValue: 180,
  icon: ServerCrashIcon,
  color: 'text-amber-500',
  bg: 'bg-amber-100 dark:bg-amber-900/50',
  border: 'border-amber-200 dark:border-amber-800'
}, {
  id: 6,
  type: 'merchant',
  title: 'New Merchant Registered',
  desc: 'Cafe Khaas (M-40112) has completed initial registration.',
  time: '4 hours ago',
  timeValue: 240,
  icon: StoreIcon,
  color: 'text-primary-500',
  bg: 'bg-primary-100 dark:bg-primary-900/50',
  border: 'border-primary-200 dark:border-primary-800'
}, {
  id: 7,
  type: 'approval',
  title: 'Merchant Approved',
  desc: 'Zeen Textile (M-30881) KYC approved by checker.',
  time: '5 hours ago',
  timeValue: 300,
  icon: CheckCircleIcon,
  color: 'text-emerald-500',
  bg: 'bg-emerald-100 dark:bg-emerald-900/50',
  border: 'border-emerald-200 dark:border-emerald-800'
}, {
  id: 8,
  type: 'alert',
  title: 'High Volume Alert',
  desc: 'Visa transactions exceeded daily threshold in Karachi.',
  time: '1 day ago',
  timeValue: 1440,
  icon: TrendingUpIcon,
  color: 'text-rose-500',
  bg: 'bg-rose-100 dark:bg-rose-900/50',
  border: 'border-rose-200 dark:border-rose-800'
}, {
  id: 9,
  type: 'merchant',
  title: 'Merchant Suspended',
  desc: 'Tech Store (M-50221) suspended due to compliance issues.',
  time: '2 days ago',
  timeValue: 2880,
  icon: AlertTriangleIcon,
  color: 'text-orange-500',
  bg: 'bg-orange-100 dark:bg-orange-900/50',
  border: 'border-orange-200 dark:border-orange-800'
}, {
  id: 10,
  type: 'system',
  title: 'Scheduled Maintenance',
  desc: 'E-commerce gateway maintenance completed successfully.',
  time: '3 days ago',
  timeValue: 4320,
  icon: ServerCrashIcon,
  color: 'text-amber-500',
  bg: 'bg-amber-100 dark:bg-amber-900/50',
  border: 'border-amber-200 dark:border-amber-800'
}];
const timeRangeLimits = {
  Today: 1440,
  Week: 10080,
  MTD: 44640,
  YTD: 525600
};
interface ActivityFeedProps {
  filters: DashboardFilters;
}
export const ActivityFeed: React.FC<ActivityFeedProps> = ({
  filters
}) => {
  const {
    timeRange
  } = filters;
  const timeLimit = timeRangeLimits[timeRange];
  const activities = allActivities.filter(a => a.timeValue <= timeLimit);
  return <Card title="Real-Time Activity" className="h-full flex flex-col" data-id="element-149">
      <div className="flex-1 overflow-y-auto pr-2 -mr-2 custom-scrollbar" data-id="element-150">
        <div className="relative border-l-2 border-slate-100 dark:border-slate-700/50 ml-4 mt-4 space-y-8 pb-6" data-id="element-151">
          {activities.length > 0 ? activities.map(activity => {
          const Icon = activity.icon;
          return <div key={activity.id} className="relative pl-8 group" data-id="element-152">
                  <div className={`absolute -left-[17px] top-0 h-8 w-8 rounded-full ${activity.bg} border-2 border-white dark:border-slate-800 flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform duration-300`} data-id="element-153">
                    <Icon className={`h-4 w-4 ${activity.color}`} strokeWidth={2.5} data-id="element-154" />
                  </div>
                  <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50 shadow-sm group-hover:shadow-md transition-shadow" data-id="element-155">
                    <div className="flex justify-between items-start mb-1.5" data-id="element-156">
                      <h4 className="text-sm font-bold text-slate-900 dark:text-white tracking-tight" data-id="element-157">
                        {activity.title}
                      </h4>
                      <span className="text-[11px] font-semibold text-slate-400 whitespace-nowrap ml-3" data-id="element-158">
                        {activity.time}
                      </span>
                    </div>
                    <p className="text-xs font-medium text-slate-500 dark:text-slate-400 leading-relaxed" data-id="element-159">
                      {activity.desc}
                    </p>
                  </div>
                </div>;
        }) : <div className="pl-8 text-sm font-medium text-slate-500 dark:text-slate-400" data-id="element-160">
              No activities in this time period
            </div>}
        </div>
      </div>
      <div className="pt-5 mt-2 border-t border-slate-100 dark:border-slate-700/50" data-id="element-161">
        <button className="w-full py-2.5 text-sm font-bold text-accent-600 dark:text-accent-400 bg-accent-50 dark:bg-accent-900/20 hover:bg-accent-100 dark:hover:bg-accent-900/40 rounded-lg transition-colors" data-id="element-162">
          View All Activity
        </button>
      </div>
    </Card>;
};